
import { FrameworkConfiguration } from 'aurelia-framework';



export function configure(config: FrameworkConfiguration) {
  config.globalResources('./elements/star-rate');
}


export * from './elements/StarRateClicked';
